var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('span', [_vm._v("O hypotéke")]), _c('img', {
    staticClass: "activate-button nav-link-icon filter-primary",
    "class": {
      'rotate': _vm.opened
    },
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f28_icons8-collapse-arrow.svg",
      "alt": ""
    },
    on: {
      "click": function click($event) {
        _vm.opened = !_vm.opened;
      }
    }
  })]), _c('v-expand-transition', {
    staticClass: "summary-items-transition"
  }, [_vm.opened ? _c('div', {
    staticClass: "summary-items-wrapper"
  }, [_c('text-value-holder', {
    attrs: {
      "label": 'hlavný účel',
      "value": _vm.mainPurpose
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'vedľajší účel',
      "value": _vm.secondaryPurpose
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'výška úveru',
      "value": _vm.totalAmount
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'splatnosť',
      "value": _vm.summaryData.splatnost + 'r'
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'fix',
      "value": _vm.summaryData.fix
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'deň splátky',
      "value": 'nedorobené'
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'čerpanie',
      "value": 'nedorobené'
    }
  })], 1) : _vm._e()])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }